import { render, staticRenderFns } from "./tableDetailsHeader.vue?vue&type=template&id=2fcd2706&scoped=true"
import script from "./tableDetailsHeader.vue?vue&type=script&lang=js"
export * from "./tableDetailsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd2706",
  null
  
)

export default component.exports